<template>
  <modal
    class="createAssetGroup"
    name="uploadBulkPOS"
    transition="pop-out"
    :width="700"
    :height="500"
    @opened="opened"
    @closed="closed"
  >
    <div class="text-center assets_modal_div">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">
        {{ $t("text.bTerminal.uploadBulkPOS") }}
      </p>

      <form>
        <div class="modal_form_field mt-4">
          <label class="assets_label required">{{
            $t("text.bTerminal.vendor")
          }}</label>

          <select class="form-control" v-model="posVendor">
            <option disabled value="select vendor">
              {{ $t("text.bTerminal.selectVendor") }}
            </option>
            <option
              v-for="(vendor, index) in vendors"
              :value="vendor.value"
              :key="index"
            >
              {{ vendor.label }}
            </option>
          </select>
        </div>

        <div class="modal_form_field mt-4">
          <label class="assets_label required">
            {{ $t("text.bTerminal.posOwner") }}
          </label>

          <select class="form-control" v-model="posOwner">
            <option disabled value="select owner">
              {{ $t("text.bTerminal.selectOwner") }}
            </option>
            <option
              v-for="(posOwner, index) in posOwners"
              :value="posOwner.value"
              :key="index"
            >
              {{ posOwner.label }}
            </option>
            <option value="other">
              {{ $t("text.bTerminal.other") }}
            </option>
          </select>
        </div>

        <div class="modal_form_field mt-4">
          <label class="assets_label required">
            {{ $t("text.bTerminal.app") }}
          </label>

          <select class="form-control" v-model="publicKey">
            <option disabled value="select public key">
              {{ $t("text.bTerminal.selectApp") }}
            </option>
            <option
              v-for="(posPK, index) in posPKs"
              :value="posPK.publicKey"
              :key="index"
            >
              {{ posPK.appName }}
            </option>
          </select>
        </div>

        <div class="mt-4 modal_form_field">
          <a
            class="h6 font-weight-medium text-success"
            href="/files/posTemplate.xlsx"
            download
          >
            <u>{{ $t("text.bTerminal.downloadTemplate") }}</u>
          </a>
        </div>

        <div class="modal_form_field mt-4">
          <label class="assets_label required">
            {{ $t("text.bTerminal.selectFile") }}
          </label>
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            :placeholder="$t('text.bTerminal.uploadBulkPOS')"
            accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
          >
          </b-form-file>
        </div>

        <button
          @click="upload"
          class="sales_target_btn"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          <span v-show="!isButtonDisabled">
            {{ $t("text.bTerminal.upload") }}
          </span>
          <img
            v-show="showSpinner"
            src="@/assets/img/git_loader.gif"
            width="30px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "uploadBulkPOS",
  props: ["companyId"],

  data() {
    return {
      isButtonDisabled: false,
      showLoader: false,
      showSpinner: false,
      posOwners: [],
      vendors: [],
      posPKs: [],
      branchId: this.$route.query.branchId ? this.$route.query.branchId : "",
      file: [],

      posVendor: "select vendor",
      posOwner: "select owner",
      publicKey: "select public key",
    };
  },
  watch: {},
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    closed() {
      this.posVendor = "select vendor";
      this.posOwner = "select owner";
      this.publicKey = "select public key";
    },
    closeModal() {
      this.$modal.hide("uploadBulkPOS");
    },
    opened() {
      this.getPosOwners();
      this.getPosVendors();
      this.getPosPublicKeys();
    },

    getPosVendors() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/POS/Vendors/${this.companyId}/company`,
          configObject.remisConfig(),
        )
        .then((response) => {
          const items = response.data.data || response.data || [];

          this.vendors = (Array.isArray(items) ? items : []).map((item) => ({
            value: item,
            label: item,
          }));
        })
        .catch((error) => {});
    },
    getPosOwners() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/POS/Owners/${this.companyId}/company`,
          configObject.remisConfig(),
        )
        .then((response) => {
          const items = response.data.data || response.data || [];

          this.posOwners = (Array.isArray(items) ? items : []).map((item) => ({
            value: item,
            label: item,
          }));
        })
        .catch((error) => {});
    },

    getPosPublicKeys() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/v2/POS/appaccounts/${this.companyId}/company`,
          configObject.authConfig(),
        )
        .then((res) => {
          this.posPKs = res.data.data;
        })
        .catch((error) => {});
    },

    upload(event) {
      event.preventDefault();

      if (this.posVendor == "select vendor") {
        this.$toast.open({
          message: this.$t("text.bTerminal.selectVendor"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.posOwner == "select owner") {
        this.$toast.open({
          message: this.$t("text.bTerminal.selectOwner"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.publicKey == "select public key") {
        this.$toast.open({
          message: this.$t("text.bTerminal.selectApp"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (!this.file || this.file.length === 0) {
        this.$toast.open({
          message: this.$t("text.bTerminal.selectFile"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let formData = new FormData();

      formData.append("Vendor", this.posVendor);
      formData.append("Owner", this.posOwner);
      formData.append("PublicKey", this.publicKey);
      formData.append("File", this.file);

      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/v2/POS/Upload/Terminal/${this.companyId}/company`,
          formData,
          configObject.authConfigForUpload(),
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.bTerminal.successfullyCreated"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("refreshTerminalsList");
          this.$modal.hide("uploadBulkPOS");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
